import { render } from "./UpgradeChart.vue?vue&type=template&id=f32d39ee"
import script from "./UpgradeChart.vue?vue&type=script&lang=js"
export * from "./UpgradeChart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__